import React from "react";
import { Link } from "react-router-dom";
import { FiChevronDown } from "react-icons/fi";
import "../styles/ServicesDropdown.css"; 

function ServicesDropdown({ onLinkClick, scrolled, menuOpen }) {
  const isArrowDark = scrolled || menuOpen;

  return (
    <div className="services-dropdown-wrapper">
      <FiChevronDown
        className={`dropdown-arrow ${
          isArrowDark ? "dropdown-arrow-dark" : "dropdown-arrow-light"
        }`}
      />
      <div className="services-dropdown-content">
        <Link to="/resources" onClick={onLinkClick}>
          Resources
        </Link>
      </div>
    </div>
  );
}

export default ServicesDropdown;